/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.14",
    versionName: "0.2.0-nightly.2026.1.14",
    versionChannel: "nightly",
    buildDate: "2026-01-14T00:09:41.281Z",
    commitHash: "b8266160442df5f2e0de241cb3f96bf81a3bd74a",
};
